exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.user_info[data-v-37a3f205] {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\n}\n.user_info .ant-row.ant-form-item[data-v-37a3f205] {\r\n    width: 100%;\r\n    margin-right: 6px;\n}\n.gx-card-widget .ant-card-head-title[data-v-37a3f205] {\r\n    padding: 0;\r\n    text-transform: uppercase;\r\n    font-size: 16px;\r\n    font-weight: 600;\n}\n.ant-card-head-title[data-v-37a3f205] {\r\n    font-weight: 600;\r\n    font-size: 15px !important;\n}\r\n", ""]);

// exports
